webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {};
  },
  name: "App"
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {

      length: 3,
      onboarding: 0,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialog7: false,
      dialog8: false,
      dialog9: false,
      dialog10: false,
      dialog11: false,
      dialog12: false,
      dialog13: false,
      icons: ['fab fa-facebook', 'fab fa-twitter', 'fab fa-google-plus', 'fab fa-linkedin', 'fab fa-instagram'],
      items: [{
        src: '../static/img/icons/Fondo1.jpg'
      }, {
        src: '../static/img/icons/Fondo2.jpg'
      }, {
        src: '../static/img/icons/Fondo3.jpg'
      }]
    };
  },

  methods: {
    next: function next() {
      this.onboarding = this.onboarding + 1 === length ? 0 : this.onboarding + 1;
    },
    prev: function prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {

      title: ''
    };
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {

      dialog9: false,
      dialog10: false,
      icons: [],
      items: [{ src: '../static/img/icons/Fondo1.jpg' }]
    };
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    data: function data() {
        return {

            dialog9: false,
            dialog10: false,

            icons: [],
            items: [{ src: '../static/img/icons/Fondo1.jpg' }]
        };
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    data: function data() {
        return {

            dialog9: false,
            dialog10: false,
            icons: [],
            items: [{ src: '../static/img/icons/Fondo1.jpg' }]
        };
    }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    data: function data() {
        return {

            dialog9: false,
            dialog10: false,
            icons: [],
            items: []
        };
    }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    data: function data() {
        return {

            dialog9: false,
            dialog10: false,
            icons: [],
            items: [{ src: '../static/img/icons/Fondo1.jpg' }]
        };
    }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    data: function data() {
        return {

            dialog9: false,
            dialog10: false,
            icons: [],
            items: [{ src: '../static/img/icons/Fondo1.jpg' }]
        };
    }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    data: function data() {
        return {

            dialog9: false,
            dialog10: false,
            icons: [],
            items: [{ src: '../static/img/icons/Fondo1.jpg' }]
        };
    }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    data: function data() {
        return {

            dialog9: false,
            dialog10: false,
            icons: [],
            items: [{ src: '../static/img/icons/Fondo1.jpg' }]
        };
    }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_free_css_all_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_free_css_all_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_free_css_all_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
 // Ensure you are using css-loader






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a, {
  iconfont: 'fa'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ef85f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(23);
function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24ef85f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ef85f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"flat":"","app":"","color":"black"}},[_c('div',[_c('v-btn',{staticClass:"hidden-md-and-up show-sm-and-down",attrs:{"icon":"","color":"white","router":"","to":"/"}},[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('a',{attrs:{"href":""}},[_c('img',{staticClass:"hidden-sm-and-down",staticStyle:{"width":"210px","heigth":"150px"},attrs:{"src":__webpack_require__(24),"alt":"logo","router":"","to":"/"}})])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"show-md-and-up hidden-sm-and-down"},[_c('v-btn',{staticClass:"white--text",attrs:{"flat":"","round":"","router":"","to":"/"}},[_c('h4',[_vm._v("Inicio")])]),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","flat":"","round":""},slot:"activator"},[_c('h4',[_vm._v("Servicios")])]),_vm._v(" "),_c('v-list',{staticClass:"black",staticStyle:{"height":"400px","opacity":".5"}},[_c('v-list-tile',{staticClass:"white--text",staticStyle:{"font-size":"10px","font-family":"'Maven Pro', sans-serif","heigth":"200px"},attrs:{"column":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","column":"","fill-height":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"fiscal"}},[_vm._v("Consultoría Fiscal")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"rh"}},[_vm._v("Recursos Humanos")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"marketing"}},[_vm._v("Marketing")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"legal"}},[_vm._v("Asesoría legal")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"logistica"}},[_vm._v("Logística Comercial")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"outsourcing"}},[_vm._v("Administración de Nómina")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"gob"}},[_vm._v("Gobierno Corporativo")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"contraloria"}},[_vm._v("Contraloría Externa")])],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"flat":"","round":"","router":"","to":"/Nosotros"}},[_c('h4',[_vm._v("Nosotros")])]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"flat":"","round":"","href":"#contacto"}},[_c('h4',[_vm._v("Contacto")])])],1),_vm._v(" "),_c('v-menu',{staticClass:"show-sm-and-down hidden-md-and-up",attrs:{"offset-x":""}},[_c('v-toolbar-side-icon',{attrs:{"slot":"activator","icon":"","color":"white"},slot:"activator"}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"flat":"","round":"","router":"","to":"/"}},[_c('h4',[_vm._v("Inicio")])]),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","flat":"","round":"","href":"/#servicios"},slot:"activator"},[_c('h4',[_vm._v("Servicios")])]),_vm._v(" "),_c('v-list',{staticClass:"black",staticStyle:{"height":"400px","opacity":".5"}},[_c('v-list-tile',{staticClass:"white--text",staticStyle:{"font-size":"10px","font-family":"'Maven Pro', sans-serif","heigth":"200px"},attrs:{"column":""}},[_c('v-layout',{attrs:{"align-center":"","justify-start":"","column":"","fill-height":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"fiscal"}},[_vm._v("Consultoría Fiscal")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"rh"}},[_vm._v("Recursos Humanos")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"marketing"}},[_vm._v("Marketing")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"legal"}},[_vm._v("Asesoría legal")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"logistica"}},[_vm._v("Logística Comercial")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"outsourcing"}},[_vm._v("Administración de Nómina")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"gob"}},[_vm._v("Gobierno Corporativo")]),_vm._v(" "),_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"contraloria"}},[_vm._v("Contraloría Externa")])],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"flat":"","round":"","router":"","to":"/Nosotros"}},[_c('h4',[_vm._v("Nosotros")])]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"flat":"","round":"","href":"#contacto"}},[_c('h4',[_vm._v("Contacto")])])],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo-Encabezado.fe1e03a.png";

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nosotros__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contacto__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_fiscal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contraloria__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_gob__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_legal__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_logistica__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_marketing__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_outsourcing__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_rh__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_formulario__ = __webpack_require__(59);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HelloWorld',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__["a" /* default */]
  }, {
    path: '/nosotros',
    name: 'Nosotros',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Nosotros__["a" /* default */]
  }, {
    path: '/contacto',
    name: 'Contacto',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Contacto__["a" /* default */]
  }, {
    path: '/fiscal',
    name: 'Fiscal',
    component: __WEBPACK_IMPORTED_MODULE_5__components_fiscal__["a" /* default */]
  }, {
    path: '/legal',
    name: 'legal',
    component: __WEBPACK_IMPORTED_MODULE_8__components_legal__["a" /* default */]
  }, {
    path: '/logistica',
    name: 'logistica',
    component: __WEBPACK_IMPORTED_MODULE_9__components_logistica__["a" /* default */]
  }, {
    path: '/marketing',
    name: 'marketing',
    component: __WEBPACK_IMPORTED_MODULE_10__components_marketing__["a" /* default */]
  }, {
    path: '/outsourcing',
    name: 'outsourcing',
    component: __WEBPACK_IMPORTED_MODULE_11__components_outsourcing__["a" /* default */]
  }, {
    path: '/gob',
    name: 'gob',
    component: __WEBPACK_IMPORTED_MODULE_7__components_gob__["a" /* default */]
  }, {
    path: '/contraloria',
    name: 'contraloria',
    component: __WEBPACK_IMPORTED_MODULE_6__components_contraloria__["a" /* default */]
  }, {
    path: '/rh',
    name: 'rh',
    component: __WEBPACK_IMPORTED_MODULE_12__components_rh__["a" /* default */]
  }, {
    path: '/formulario',
    name: 'formulario',
    component: __WEBPACK_IMPORTED_MODULE_13__components_formulario__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca86e304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__(29);
function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca86e304_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{attrs:{"dark":"","src":"../static/img/icons/Fondo1.jpg","height":"650"}},[_c('v-layout',{staticStyle:{"margin-top":"80px"},attrs:{"pt-5":"","align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"pt-5":"","src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('span',{staticStyle:{"font-size":"45px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Somos el complemento perfecto"),_c('br'),_vm._v(" "),_c('b',[_vm._v("para tu empresa")])])])],1)]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":"","hidden-md-and-down":""}},[_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"fiscal"}},[_vm._v("Consultoría "),_c('br'),_vm._v(" Fiscal")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"rh"}},[_vm._v("Recursos "),_c('br'),_vm._v(" Humanos")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"marketing"}},[_vm._v("Marketing")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"legal"}},[_vm._v("Asesoría "),_c('br'),_vm._v(" legal")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"logistica"}},[_vm._v("Logística "),_c('br'),_vm._v(" Comercial")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"outsourcing"}},[_vm._v("Administración "),_c('br'),_vm._v(" de Nómina")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"gob"}},[_vm._v("Gobierno "),_c('br'),_vm._v(" Corporativo")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"contraloria"}},[_vm._v("Contraloría "),_c('br'),_vm._v(" Externa")])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"servicios"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-xs-center"},[_c('h4',{staticClass:"font-weight-thin"},[_vm._v("Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-xs-center"},[_c('h5',{staticClass:"font-weight-thin"},[_vm._v("Con servicio en todo México")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","hidden-md-and-down":""}},[_c('v-card',{attrs:{"color":"transparent","flat":""}},[_c('v-card',{staticClass:"portrait",staticStyle:{"margin-left":"250px"},attrs:{"img":"../static/img/icons/Tramado1.png","height":"110","width":"270","flat":""}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-card',{attrs:{"color":"transparent","flat":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-space-around":"","fill-height":""}},[_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.dialog1),callback:function ($$v) {_vm.dialog1=$$v},expression:"dialog1"}},[_c('v-hover',{attrs:{"slot":"activator","color":"deep-orange accent-4","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/picfiscal.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/Consultoria-fiscal_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Consultoría Fiscal\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v(" Administración y Asesoría en "),_c('br'),_vm._v("Litigio Fiscal.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Asesoría a Emprendedores.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Contabilidad Administrativa y Fiscal.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Planificación de Activos y Patrimonios.")]),_c('br')])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog1 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/consultoria_fiscal.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            El área de consultoría fiscal brinda todo \n                                            tipo de asesoría en materia de impuestos federales\n                                            y locales, nuestro objetivo es proporcionar a \n                                            nuestros clientes soluciones reales de manera \n                                            oportuna, siempre con estricto apego al mercado \n                                            legal aplicable.\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"primary","dark":"","route":"","to":"fiscal"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Consultoría "),_c('br'),_vm._v(" Fiscal")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-hover',{attrs:{"slot":"activator","color":"red lighten-2","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/rh.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/recursos-humanos_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Recursos Humanos\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v(" Políticas y Procedimientos de "),_c('br'),_vm._v(" Capital Humano.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Manual de Capacitación y "),_c('br'),_vm._v("\n                                                    Reglamento Interno de Trabajo.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Métodos de Evaluación y "),_c('br'),_vm._v("\n                                                    Diagnóstico del Desempeño.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Identidad Corporativa y "),_c('br'),_vm._v(" Gestión de Talentos.")]),_c('br')])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog2 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/recursos humanos.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Obtener, mantener y desarrollar el capital humano \n                                            que cumpla de manera eficiente con los Valores y \n                                            Objetivos de la Organización por medio de una planeación \n                                            estratégica del área de capital humano, Formación y Atracción de Talento, \n                                            Desarrollo Organizacional, Cultura y Comunicación de las Organizaciones.\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"pink","dark":"","route":"","to":"rh"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Recursos "),_c('br'),_vm._v(" Humanos")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.dialog3),callback:function ($$v) {_vm.dialog3=$$v},expression:"dialog3"}},[_c('v-hover',{attrs:{"slot":"activator","color":"red lighten-2","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/law.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/asesoria-legal_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Asesoría Legal\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Asistencia y asesoría jurídica "),_c('br'),_vm._v(" especializada en cualquier rama del Derecho.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Elaboración de dictámenes.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Representación Letrada.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Asesoría Jurídica Empresarial(nuevo).")]),_c('br')])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog3 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/asesoria legal.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Contamos con asesoría legal en la áreas: Laboral, \n                                            Penal, Civil, Empresarial, Propiedad intelectual.\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"red","dark":"","route":"","to":"legal"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Asesoría "),_c('br'),_vm._v(" Legal")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.dialog4),callback:function ($$v) {_vm.dialog4=$$v},expression:"dialog4"}},[_c('v-hover',{attrs:{"slot":"activator","color":"red lighten-2","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/mark.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/marketing_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Marketing\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Generación de contenidos "),_c('br'),_vm._v("\n                                                   para la atracción de potenciales "),_c('br'),_vm._v("\n                                                   clientes.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Automatización de procesos "),_c('br'),_vm._v(" \n                                                    internos y externos para "),_c('br'),_vm._v(" \n                                                    captación y gestión de clientes.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Realización y presentación de "),_c('br'),_vm._v("\n                                                    propuestas de marketing para "),_c('br'),_vm._v("\n                                                    potenciales clientes.")]),_c('br')])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog4 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/marketing.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Manejamos contenidos generales y variados que \n                                            ofrecen soluciones de comunicación de marketing \n                                            diferenciadas y optimizadas a lo que cada cliente\n                                             requiera, a través de contenidos atractivos e \n                                             innovadores.\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"blue","dark":"","route":"","to":"marketing"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Marketing")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.dialog6),callback:function ($$v) {_vm.dialog6=$$v},expression:"dialog6"}},[_c('v-hover',{attrs:{"slot":"activator","color":"red lighten-2","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/logis.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/Logistica-comercial_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Logística Comercial\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Estudio de viabilidad técnica "),_c('br'),_vm._v("\n                                                     y Comercial.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Análisis de Clientes, Competidores "),_c('br'),_vm._v("\n                                                     y Herramientas potenciales.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Análisis de Rentabilidad y Costos "),_c('br'),_vm._v("\n                                                   para determinación de "),_c('br'),_vm._v("\n                                                    precios de mercado.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Preparación de Estrategias "),_c('br'),_vm._v("\n                                                   de Ventas globales.")])])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog6 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/logistica comercial.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Proporcionar las estrategias que permitan alcanzar de manera oportuna y eficiente \n                                            los objetivos de ventas, rentabilidad, crecimiento y participación de mercado esperados \n                                            por la empresa. Asesoría logística de compras y rutas eficientes de reparto, gestión de \n                                            transporte internacional (marítimo, terrestre, aéreo), evaluación de participación de\n                                             mercados, preparación de estrategias de precios y rentabilidad para el sector de reta\n                                            planeación de rutas de clientes y formatos de supervisión de actividades y medición de \n                                            resultados.\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"green","dark":"","route":"","to":"logistica"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Logística "),_c('br'),_vm._v(" Comercial")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"700"},model:{value:(_vm.dialog7),callback:function ($$v) {_vm.dialog7=$$v},expression:"dialog7"}},[_c('v-hover',{attrs:{"slot":"activator","color":"red lighten-2","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/grupo.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/outsourcing_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Administración de Nómina\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Administración correcta de personal.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Asesoría para el cumplimiento de "),_c('br'),_vm._v("\n                                                    obligaciones patronales y fiscales.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Cálculo y preparación de Nóminas.")]),_c('br')])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog7 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/outsourcing.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Implementamos innovadoras estrategias de Back Office para la \n                                            Administración de Personal, que otorgan a nuestros clientes \n                                            certidumbre y tranquilidad. Nuestros servicios permiten mantener\n                                             la estructura actual de la empresa, aportando valor al compartir \n                                             nuestra experiencia y brindando beneficios; respetando en todos \n                                             los aspectos la Ley Federal del Trabajo, la Ley del Seguro Social\n                                              y la Ley del Impuesto Sobre la Renta, optimizando el cumplimiento \n                                              de sus obligaciones fiscales y laborales; Manteniendo las garantías \n                                              laborales; Simplificando procesos administrativos; Ahorrando tiempos\n                                               y recursos; Y contando además con asesoría laboral.\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"purple","dark":"","route":"","to":"outsourcing"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Administración "),_c('br'),_vm._v(" de Nómina")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"700"},model:{value:(_vm.dialog12),callback:function ($$v) {_vm.dialog12=$$v},expression:"dialog12"}},[_c('v-hover',{attrs:{"slot":"activator","color":"red lighten-2","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/corp.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/gob-corporativo_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Gobierno Corporativo\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Talleres de facilitación y capacitación.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Diseño y Evaluación de marcos de "),_c('br'),_vm._v(" \n                                                gobierno corporativo que incluyen la definición "),_c('br'),_vm._v("\n                                                 del Consejo de Administración, \n                                                 "),_c('br'),_vm._v(" del Comité de Auditoría, etc.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Asesoría en la conformación de planes de sucesión.")]),_c('br')])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog12 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/gob corporativo.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Institucionalizar el gobierno corporativo en las empresas resulta \n                                            clave para fortalecerlas mediante la transparencia y la gestión \n                                            profesional. El proceso demanda la asesoría de expertos para \n                                            construir una reputación de alto valor agregado, apuntalar la \n                                            confianza, y acceder a mercados y financiamiento en condiciones \n                                            óptimas para lograr los objetivos del negocio.\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"grey","dark":"","route":"","to":"gob"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Gobierno "),_c('br'),_vm._v(" Corporativo")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",attrs:{"width":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.dialog13),callback:function ($$v) {_vm.dialog13=$$v},expression:"dialog13"}},[_c('v-hover',{attrs:{"slot":"activator","color":"red lighten-2","dark":""},slot:"activator",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-avatar',{class:("elevation-" + (hover ? 12 : 2)),attrs:{"size":"150px"}},[_c('v-img',{attrs:{"src":"../static/img/icons/contra.jpg","alt":""}},[_c('v-expand-transition',[(hover)?_c('div',{staticClass:"d-flex transition-fast-in-fast-out \n                                    red darken-2 v-card--reveal display-6 white--text",staticStyle:{"height":"100%"}},[_vm._v("\n                                    Ver más\n                                  ")]):_vm._e()])],1)],1)}}])}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"white"}},[_c('v-layout',[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","src":"../static/img/icons/Contraloria-externa_pre.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            Contraloría Externa\n                                          ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subheading",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Procesamiento de registros contables y "),_c('br'),_vm._v("\n                                                 análisis financieros periódicos..")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Revisión de los objetivos, "),_c('br'),_vm._v("\n                                                    planes y programas de la empresa, "),_c('br'),_vm._v("\n                                                    su estructura orgánica y funciones; "),_c('br'),_vm._v("\n                                                  sistemas, procedimientos, "),_c('br'),_vm._v("\n                                                   manuales y controles.")]),_c('br'),_vm._v(" "),_c('li',[_vm._v("Revisiones específicas de las áreas "),_c('br'),_vm._v(" \n                                                    operativas de la empresa.")]),_c('br')])])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"fab":"","small":"","color":"black","flat":""},on:{"click":function($event){_vm.dialog13 = false}}},[_vm._v("\n                                        X\n                                      ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('v-img',{staticClass:"white--text",attrs:{"height":"auto","width":"auto","src":"../static/img/icons/contraloria externa.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-5 subhebody-2 text-xs-left black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                                            La consultoría le permite definir los planes y programas \n                                            necesarios para optimizar las funciones administrativas y \n                                            financieras de la empresa, con los cuales se obtenga la\n                                             eficiencia en la administración de sus recursos\n                                          ")])])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"text-none",attrs:{"round":"","color":"amber","dark":"","route":"","to":"contraloria"}},[_vm._v("Más información")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"font-weight-thin text-xs-center"},[_vm._v("Contraloría "),_c('br'),_vm._v(" Externa")])])])])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',[_c('v-img',{attrs:{"src":"../static/img/icons/Fondo-frase.jpg"}},[_c('v-card-text',{staticClass:"display-1 text-xs-center white--text",attrs:{"pt-5":""}},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('h4',{staticClass:"font-weight-thin"},[_vm._v(" \"La mente que se abre a una nueva idea "),_c('br'),_vm._v(" jamás volverá a su tamaño original.\"")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin font-italic white--text"},[_c('h5',[_vm._v("-Albert Einstein")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"40px","max-height":"40px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/GH icon.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"text-sm-center",staticStyle:{"font-size":"25px","color":"black","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Sé parte de las empresas que "),_c('br'),_vm._v(" ya confian en Genial HUB\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","color":"#CD2800","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Algunas de las industrias satisfechas con nuestros servicios:\n          ")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-card-text')],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-card-text',[_vm._v("Construcción de "),_c('br'),_c('b',[_vm._v("Carreteras y Obra Civil")])]),_vm._v(" "),_c('v-img',{attrs:{"src":"../static/img/icons/linea naranja.png"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-card-text',[_vm._v("Mantenimiento de "),_c('br'),_c('b',[_vm._v("Transporte y Maquinaria")])]),_vm._v(" "),_c('v-img',{attrs:{"src":"../static/img/icons/linea naranja.png"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-card-text',[_vm._v("Consultoría de Servicios "),_c('br'),_c('b',[_vm._v("de Administración")])]),_vm._v(" "),_c('v-img',{attrs:{"src":"../static/img/icons/linea naranja.png"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-card-text',[_vm._v("Comercio "),_c('br'),_c('b',[_vm._v(" y Distribución")])]),_vm._v(" "),_c('v-img',{attrs:{"src":"../static/img/icons/linea naranja.png"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-card-text',[_vm._v("Taller de Fabricación de "),_c('br'),_c('b',[_vm._v("Muebles y Equipo de Protección")])]),_vm._v(" "),_c('v-img',{attrs:{"src":"../static/img/icons/linea naranja.png"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-card-text')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-container',{staticStyle:{"background-color":"#EAEAEA"},attrs:{"fluid":"","px-0":"","mx-0":""}},[_c('v-layout',{attrs:{"row":"","hidden-md-and-down":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":"","md1":""}},[_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-card',{attrs:{"img":"../static/img/icons/Tramado.png","height":"100","width":"100","flat":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('br'),_c('br'),_vm._v(" "),_c('v-card',{staticStyle:{"background-color":"#EAEAEA"},attrs:{"tile":"","flat":""}},[_c('v-card-title',{staticClass:"pl-5 display-2 font-weight-light"},[_c('h4',[_vm._v("Contacto")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{staticClass:"pl-5"},[_c('v-icon',{staticStyle:{"color":"white","background-color":"#CD2800"}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"ml-3"},[_c('h5',[_vm._v("+52 (999) 518 0708")])])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{staticClass:"pl-5"},[_c('v-icon',{staticStyle:{"color":"white","background-color":"#CD2800"}},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"ml-3"},[_c('h5',[_vm._v("contacto@genialhub.com")])])],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left pl-5"},[_c('v-btn',{attrs:{"round":"","color":"#CD2800","dark":"","route":"","to":"formulario"}},[_vm._v("Solicitar Consulta")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',{attrs:{"tile":"","flat":"","color":"transparent"}},[_c('iframe',{staticClass:"pl-5",staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3725.0389386050297!2d-89.59621258591244!3d20.991076194441515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f56712e8fea7881%3A0x83b6a851b1d52dc0!2zQ2FsbGUgMzHhtK4gMTQ1LCBOdWV2YSBBbGVtw6FuLCA5NzE0NiBNw6lyaWRhLCBZdWMu!5e0!3m2!1ses!2smx!4v1544815314466","width":"460","height":"350","frameborder":"0"}})])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',[_c('v-img',{attrs:{"src":"../static/img/icons/Fondo-pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('h4',[_vm._v("¡Gracias por tu visita!")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('h4',[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nosotros_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25fd1842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nosotros_vue__ = __webpack_require__(32);
function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nosotros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25fd1842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nosotros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{attrs:{"dark":"","src":"../static/img/icons/Portada-Nosotros.jpg","height":"650"}},[_c('v-layout',{staticStyle:{"margin-top":"80px"},attrs:{"pt-5":"","align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"170px","max-height":"170px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"pt-5":"","src":"../static/img/icons/Logo blanco.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('span',{staticStyle:{"font-size":"45px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Somos una Empresa de Consultoría Integral Empresarial"),_c('br'),_vm._v(" "),_c('b',[_vm._v("que concentra profesionales en los ámbitos:")])])])],1)]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":"","hidden-md-and-down":""}},[_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"fiscal"}},[_vm._v("Consultoría "),_c('br'),_vm._v(" Fiscal")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"rh"}},[_vm._v("Recursos "),_c('br'),_vm._v(" Humanos")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"marketing"}},[_vm._v("Marketing")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"legal"}},[_vm._v("Asesoría "),_c('br'),_vm._v(" legal")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"logistica"}},[_vm._v("Logística "),_c('br'),_vm._v(" Comercial")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"outsourcing"}},[_vm._v("Outsourcing "),_c('br'),_vm._v(" Laboral")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"gob"}},[_vm._v("Gobierno "),_c('br'),_vm._v(" Corporativo")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-card',{staticClass:"text-xs-center",staticStyle:{"font-size":"15px","font-family":"'Maven Pro', sans-serif"},attrs:{"color":"transparent","flat":""}},[_c('v-btn',{staticClass:"transparent white--text",attrs:{"route":"","to":"contraloria"}},[_vm._v("Contraloría "),_c('br'),_vm._v(" Externa")])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-card',{staticClass:"black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"tile":"","flat":""}},[_c('v-card-text',{staticClass:"text-xs-right pr-0 subheading"},[_c('br'),_c('br'),_vm._v("\n            Implementamos estrategias"),_c('br'),_vm._v("\n             ejecutando un "),_c('b',{staticStyle:{"color":"#CD2800"}},[_vm._v("plan de negocios")]),_c('br'),_vm._v("\n              que permitan generar "),_c('b',{staticStyle:{"color":"#CD2800"}},[_vm._v("soluciones y"),_c('br'),_vm._v(" \n            beneficios para nuestros clientes.")]),_c('br'),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"text-xs-center px-0 subheading"},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticClass:"mt-3 pt-3",staticStyle:{"max-width":"60px","max-height":"60px","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/GH icon.png"}}),_vm._v(" "),_c('br'),_c('br'),_c('br')],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-card',{staticClass:"black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"tile":"","flat":""}},[_c('v-card-text',{staticClass:"text-xs-left pl-0 subheading"},[_c('br'),_c('br'),_vm._v("\n            Nuestros servicios representan la"),_c('br'),_vm._v(" "),_c('b',{staticStyle:{"color":"#CD2800"}},[_vm._v("tranquilidad, seguridad y confianza")]),_vm._v(" de"),_c('br'),_vm._v(" \n             contar con el respaldo de un "),_c('b',{staticStyle:{"color":"#CD2800"}},[_vm._v("equipo"),_c('br'),_vm._v("\n             profesional, experto y multidisciplinario.")]),_c('br'),_vm._v(" "),_c('br'),_c('br')])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"text-xs-center px-0 subheading"},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{attrs:{"contain":"","src":"../static/img/icons/Banner_nosotros.png"}}),_vm._v(" "),_c('br'),_c('br'),_c('br')],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{staticStyle:{"background-color":"white"}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-img',{staticStyle:{"max-width":"300px","max-height":"350px","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/Tramado1.png","aspect-ratio":"2.5","flat":""}})],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#CD2800","font-family":"'Maven Pro', sans-serif"},attrs:{"tile":"","flat":""}},[_c('v-card-text',{staticClass:"text-xs-center subheading"},[_c('br'),_c('br'),_vm._v("\n            MISIÓN"),_c('br'),_c('br'),_vm._v("\n            Ser un socio comercial altamente eficiente con cada uno de"),_c('br'),_vm._v("\n            nuestros clientes, absorbiendo de su operación todo aquello"),_c('br'),_vm._v("\n            que no esté dentro del objetivo principal de su empresa."),_c('br'),_vm._v("\n            Logrando que el cliente enfoque todos sus recursos para"),_c('br'),_vm._v("\n            alcanzar sus metas.\n            "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-card',{staticClass:"white--text",staticStyle:{"background-color":"#212121","font-family":"'Maven Pro', sans-serif"},attrs:{"tile":"","flat":""}},[_c('v-card-text',{staticClass:"text-xs-center subheading"},[_c('br'),_c('br'),_vm._v("\n            VISIÓN"),_c('br'),_c('br'),_vm._v("\n            Consolidarnos como líderes en el sector empresarial,"),_c('br'),_vm._v("\n            teniendo la mejor opción en cada uno de los servicios que"),_c('br'),_vm._v("\n            ofrecemos, a través de la implementación de las mejores"),_c('br'),_vm._v("\n            prácticas y estrategias, generando soluciones geniales. "),_c('br'),_vm._v(" "),_c('br'),_c('br')])],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-container',{staticStyle:{"background-color":"#EAEAEA"},attrs:{"fluid":"","px-0":"","mx-0":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","md1":""}},[_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-card',{attrs:{"img":"../static/img/icons/Tramado.png","height":"100","width":"100","flat":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","md5":""}},[_c('br'),_c('br'),_vm._v(" "),_c('v-card',{staticStyle:{"background-color":"#EAEAEA"},attrs:{"tile":"","flat":""}},[_c('v-card-title',{staticClass:"pl-5 display-2 font-weight-light"},[_c('h4',[_vm._v("Contacto")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{staticClass:"pl-5"},[_c('v-icon',{staticStyle:{"color":"white","background-color":"#CD2800"}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"ml-3"},[_c('h5',[_vm._v("Calle 31ᴮ 145, Nueva Alemán, 97146 Mérida, Yuc.")])])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{staticClass:"pl-5"},[_c('v-icon',{staticStyle:{"color":"white","background-color":"#CD2800"}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"ml-3"},[_c('h5',[_vm._v("+52 (999) 518 0708")])])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',{staticClass:"pl-5"},[_c('v-icon',{staticStyle:{"color":"white","background-color":"#CD2800"}},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"ml-3"},[_c('h5',[_vm._v("contacto@genialhub.com")])])],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left pl-5"},[_c('v-btn',{attrs:{"round":"","color":"#CD2800","dark":"","route":"","to":"formulario"}},[_vm._v("Solicitar Consulta")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',{attrs:{"tile":"","flat":"","color":"transparent"}},[_c('iframe',{staticClass:"pl-5",staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3725.0389386050297!2d-89.59621258591244!3d20.991076194441515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f56712e8fea7881%3A0x83b6a851b1d52dc0!2zQ2FsbGUgMzHhtK4gMTQ1LCBOdWV2YSBBbGVtw6FuLCA5NzE0NiBNw6lyaWRhLCBZdWMu!5e0!3m2!1ses!2smx!4v1544815314466","width":"460","height":"350","frameborder":"0"}})])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{attrs:{"xs12":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/Fondo-pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('h4',[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('h4',[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacto_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69fa9a15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacto_vue__ = __webpack_require__(34);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69fa9a15_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-space-around":"","fill-height":""}},[_c('v-flex',{attrs:{"d-flex":"","xs2":""}},[_c('div',[_c('v-btn',{attrs:{"color":"#CD2800","dark":""}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("fa fa-phone")]),_vm._v("+52 (999) 518 0708\r\n            ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"#CD2800","dark":"","href":"mailto:contacto@genialhub.com"}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("fas fa-envelope")]),_vm._v("\r\n                contacto@genialhub.com\r\n            ")],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","large":"","color":"#CD2800","target":"_blank","href":"https://www.facebook.com/Genial-Hub-Consultores-540498249719597/"}},[_c('i',{staticClass:"fab fa-facebook-square fa-3x"})])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs4":""}},[_c('v-card',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3725.0389386050297!2d-89.59621258591244!3d20.991076194441515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f56712e8fea7881%3A0x83b6a851b1d52dc0!2zQ2FsbGUgMzHhtK4gMTQ1LCBOdWV2YSBBbGVtw6FuLCA5NzE0NiBNw6lyaWRhLCBZdWMu!5e0!3m2!1ses!2smx!4v1544815314466","width":"460","height":"450","frameborder":"0","allowfullscreen":""}}),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',{staticClass:"grey--text"}),_c('br'),_vm._v(" "),_c('span',[_vm._v("Genial Hub")]),_c('br'),_vm._v(" "),_c('span')])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fiscal_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6c3364_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fiscal_vue__ = __webpack_require__(37);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fiscal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6c3364_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fiscal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/Consultoria-fiscal_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Consultoría Fiscal\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/consultoria_fiscal.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  El área de consultoría fiscal brinda todo "),_c('br'),_vm._v("\n                  tipo de asesoría en materia de impuestos "),_c('br'),_vm._v(" federales\n                  y locales, nuestro objetivo es proporcionar a "),_c('br'),_vm._v("\n                  nuestros clientes soluciones reales de manera "),_c('br'),_vm._v("\n                  oportuna, siempre con estricto apego al mercado "),_c('br'),_vm._v("\n                  legal aplicable.\n              ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/picfiscal.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"primary","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v(" Administración y Asesoría en "),_c('br'),_vm._v("Litigio Fiscal.")]),_vm._v(" "),_c('li',[_vm._v("Asesoría a Emprendedores.")]),_vm._v(" "),_c('li',[_vm._v("Contabilidad Administrativa y Fiscal.")]),_vm._v(" "),_c('li',[_vm._v("Planificación de Activos y Patrimonios.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_c('b',{staticStyle:{"color":"blue"}},[_vm._v("Responsabilidad tributaria.")]),_vm._v(" "),_c('br'),_vm._v("\n                      Es responsable solidario si participa activamente en el cometido "),_c('br'),_vm._v("\n                       de infracciones fiscales. La responsabilidad solidaria también afecta\n                        a la sanción. "),_c('br'),_c('br'),_vm._v(" "),_c('b',{staticStyle:{"color":"blue"}},[_vm._v("Responsabilidad penal.")]),_vm._v(" "),_c('br'),_vm._v("\n                      Aunque es el contribuyente el responsable penal de una infracción tributaria, \n                      el asesor puede verse afectado si se demuestra que su participación ha sido\n                       imprescindible para la comisión del delito. "),_c('br'),_c('br'),_vm._v(" "),_c('b',{staticStyle:{"color":"blue"}},[_vm._v("Responsabilidad civil.")]),_vm._v(" "),_c('br'),_vm._v("\n                      Un servicio negligente o defectuoso puede acarrear responsabilidades del asesor \n                      frente a su cliente, aunque ello no implique, necesariamente, que deba asumir\n                       las sanciones o cuantías con las que su cliente deba responder frente a la \n                       Administración tributaria.\n                  ")])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/Consultoria-fiscal_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contraloria_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de035d5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contraloria_vue__ = __webpack_require__(40);
function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contraloria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de035d5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contraloria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/Contraloria-externa_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Contraloría Externa\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/contraloria externa.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  La consultoría le permite definir los planes"),_c('br'),_vm._v("\n                   y programas necesarios para optimizar las funciones"),_c('br'),_vm._v("\n                   administrativas y financieras de la empresa, con los"),_c('br'),_vm._v(" \n                   cuales se obtenga la eficiencia en la administración de sus recursos.\n\n              ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/contra.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"amber","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Procesamiento de registros contables y análisis "),_c('br'),_vm._v(" financieros periódicos.")]),_vm._v(" "),_c('li',[_vm._v("Revisión de los objetivos, planes y programas "),_c('br'),_vm._v(" de la empresa, su estructura orgánica y "),_c('br'),_vm._v(" funciones; sistemas, procedimientos, "),_c('br'),_vm._v(" manuales y controles.")]),_vm._v(" "),_c('li',[_vm._v("Revisiones específicas de las áreas "),_c('br'),_vm._v(" operativas de la empresa.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_vm._v("\n                      El servicio de Contraloría Externa, también llamado Outsourcing Contable, no es un concepto nuevo. Este servicio es de especial interés para empresas que prefieren concentrarse en sus objetivos fundamentales de negocio y para emprendedores que prefieren iniciar actividades con la tranquilidad de que el área contable es manejada por expertos. "),_c('br'),_c('br'),_vm._v("\n\n                      Esta división presta una variedad de servicios que van desde los procedimientos necesarios para empezar un nuevo negocio hasta las complejas tareas administrativas requeridas para competir en la actual economía global. Esto le permite agilidad de respuesta y una reducción de costos significativa para su empresa. "),_c('br'),_c('br'),_vm._v("\n\n                      Nuestra metodología de trabajo para servicios de outsourcing transferirá a nuestros especialistas la administración contable de su organización, elevando los estándares de su empresa a un nivel internacional de calidad. "),_c('br'),_c('br')])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/Contraloria-externa_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gob_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7bbe07_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gob_vue__ = __webpack_require__(43);
function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7bbe07_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gob_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/gob-corporativo_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Gobierno Corporativo\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/gob corporativo.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Institucionalizar el gobierno corporativo"),_c('br'),_vm._v("\n                   en las empresas resulta clave para fortalecerlas"),_c('br'),_vm._v("\n                    mediante la transparencia y la gestión profesional."),_c('br'),_vm._v("\n                     El proceso demanda la asesoría de expertos para"),_c('br'),_vm._v("\n                      construir una reputación de alto valor agregado,"),_c('br'),_vm._v("\n                       apuntalar la confianza, y acceder a mercados y"),_c('br'),_vm._v("\n                        financiamiento en condiciones óptimas para lograr"),_c('br'),_vm._v("\n                         los objetivos del negocio.\n\n              ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/corp.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"grey","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Talleres de facilitación y capacitación.")]),_vm._v(" "),_c('li',[_vm._v("Diseño y Evaluación de marcos de gobierno "),_c('br'),_vm._v("\n                           corporativo que incluyen la definición del Consejo "),_c('br'),_vm._v("\n                            de Administración, del Comité de Auditoría, etc.")]),_vm._v(" "),_c('li',[_vm._v("Asesoría en la conformación de planes de sucesión.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_vm._v("\n                      El gobierno corporativo obedece a principios universales, pero debe ser distinto y único para adaptarse a la singularidad de cada empresa, y al nivel de madurez que hayan alcanzado las prácticas de su Alta Dirección. "),_c('br'),_c('br'),_vm._v("\n\n                      Sin reglas precisas ni administración empresarial que den claridad a la responsabilidad, derechos y obligaciones en la empresa, las decisiones se basan en intereses personales, apartándose de los objetivos del negocio y poniendo en riesgo a la organización. "),_c('br'),_c('br'),_vm._v("\n\n                      Actualmente, uno de los principales retos para las empresas es lograr su permanencia en el tiempo. Nuestra asesoría lo ayudará a construir plataformas eficientes de gobierno corporativo con múltiples beneficios para su organización.\n\n                  ")])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/gob-corporativo_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_legal_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcc4a8ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_legal_vue__ = __webpack_require__(46);
function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_legal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcc4a8ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_legal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/asesoria-legal_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Asesoría Legal\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/asesoria legal.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Contamos con asesoría legal en la áreas:"),_c('br'),_vm._v("\n                   Laboral, Penal, Civil, Empresarial, "),_c('br'),_vm._v("\n                   Propiedad intelectual.\n\n              ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/law.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"red","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Asistencia y asesoría jurídica especializada "),_c('br'),_vm._v(" en cualquier rama del Derecho.")]),_vm._v(" "),_c('li',[_vm._v("Elaboración de dictámenes.")]),_vm._v(" "),_c('li',[_vm._v("Representación Letrada.")]),_vm._v(" "),_c('li',[_vm._v("Asesoría Jurídica Empresarial (nuevo).")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_c('b',{staticStyle:{"color":"red"}},[_vm._v("Asesoría Jurídica Empresarial")]),_vm._v("\n                      Pues la asesoría jurídica empresarial tiene el mismo objetivo de proteger, guiar y asesorar en el cumplimiento estricto de la ley que corresponda, pero se complica más porque necesita del conocimiento profundo de las leyes tributarias, la contabilidad, las finanzas. En fin, un asesor jurídico de empresas debe ser un económico pero con mayor dominio de las leyes que rigen en la economía, las sociedades, el Derecho Internacional Público. "),_c('br'),_c('br'),_vm._v("\n\n                      Con nosotros no solamente encontrará únicamente al asesor jurídico empresarial, tendrá un equipo que será mayor y más complejo en dependencia del tamaño de sus necesidades.  Ofrecemos el valor del Derecho Empresarial como una Herramienta de Gestión y Asesoría a empresas para bajar los costos disminuyendo pagos por productos y servicios en el marco de lo permitido por las instancias y leyes que apliquen.\n                  ")])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/asesoria-legal_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logistica_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8be676_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logistica_vue__ = __webpack_require__(49);
function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logistica_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8be676_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logistica_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/Logistica-comercial_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Logística Comercial\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/logistica comercial.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Proporcionar las estrategias que permitan"),_c('br'),_vm._v("\n                   alcanzar de manera oportuna y eficiente"),_c('br'),_vm._v("\n                    los objetivos de ventas, rentabilidad,"),_c('br'),_vm._v("\n                     crecimiento y participación de mercado"),_c('br'),_vm._v("\n                      esperados por la empresa. Asesoría logística de compras"),_c('br'),_vm._v("\n                       y rutas eficientes de reparto,"),_c('br'),_vm._v("\n                        gestión de transporte internacional"),_c('br'),_vm._v("\n                         (marítimo, terrestre, aéreo), evaluación de"),_c('br'),_vm._v("\n                          participación de mercados, preparación de"),_c('br'),_vm._v("\n                           estrategias de precios y rentabilidad para"),_c('br'),_vm._v("\n                            el sector de retail, planeación de rutas"),_c('br'),_vm._v("\n                             de clientes y formatos de supervisión de"),_c('br'),_vm._v("\n                              actividades y medición de resultados.\n\n              ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/logis.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"green","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Estudio de viabilidad técnica y Comercial.")]),_vm._v(" "),_c('li',[_vm._v("Análisis de Clientes, Competidores y  "),_c('br'),_vm._v(" Herramientas potenciales.")]),_vm._v(" "),_c('li',[_vm._v("Análisis de Rentabilidad y Costos para determinación "),_c('br'),_vm._v(" de precios de mercado.")]),_vm._v(" "),_c('li',[_vm._v("Preparación de Estrategias de Ventas globales.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_vm._v("\n                      Se suele definir la logística como la parte del proceso de gestión de la cadena de suministro encargada de planificar, implementar, y controlar de forma eficiente y efectiva el almacenaje y flujo directo e inverso de los bienes, servicios y toda la información relacionada con éstos, entre el punto de origen y el punto de consumo, con el propósito de cumplir con las expectativas del/de la consumidora, pero nosotros nos encargamos de hacer eficiente esa labor para poder Colaborar en el cumplimiento económico de ventas: volumen y rentabilidad financiera, basados en el principal objetivo de una empresa que es ayudar a los clientes a optimizar los recursos necesarios mediante la racionalización de procesos logísticos y productivos.  \n\n                  ")])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/Logistica-comercial_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketing_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa9bb00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketing_vue__ = __webpack_require__(52);
function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa9bb00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/marketing_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Marketing\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/marketing.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Manejamos contenidos generales y"),_c('br'),_vm._v("\n                  variados que ofrecen soluciones de"),_c('br'),_vm._v("\n                   comunicación de marketing diferenciadas"),_c('br'),_vm._v("\n                    y optimizadas a lo que cada cliente requiera,"),_c('br'),_vm._v("\n                      a través de contenidos atractivos e innovadores.\n\n              ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/mark.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"primary","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Generación de contenidos para la atracción "),_c('br'),_vm._v(" de potenciales clientes.")]),_vm._v(" "),_c('li',[_vm._v("Automatización de procesos internos y externos "),_c('br'),_vm._v(" para captación y gestión de clientes.")]),_vm._v(" "),_c('li',[_vm._v("Realización y presentación de propuestas de "),_c('br'),_vm._v(" marketing para potenciales clientes.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_vm._v("\n                      Otorgamos la Asesoría profesional suficiente que pueda Combinar adecuadamente las necesidades del cliente con la oferta de Valor de los productos, a través de diversas habilidades relacionadas con el estudio del mercado, reconocimiento de las características que motivan a los consumidores a comprar y, sobre todo, diseñar e implementar estrategias para generar el éxito comercial de negocios y empresas. "),_c('br'),_c('br'),_vm._v("\n                      \n                      Es un trabajo profesional que incluye el conocimiento del mercado y la gestión de medios para poder aumentar los porcentajes de éxito en las estrategias globales de las organizaciones.\n\n                  ")])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/marketing_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_outsourcing_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d9440e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_outsourcing_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_outsourcing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1d9440e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_outsourcing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/outsourcing_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Administración de Nómina\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/outsourcing.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Implementamos innovadoras estrategias"),_c('br'),_vm._v("\n                   de Back Office para la Administración"),_c('br'),_vm._v("\n                    de Personal, que otorgan a nuestros"),_c('br'),_vm._v("\n                     clientes certidumbre y tranquilidad."),_c('br'),_vm._v("\n                      Nuestros servicios permiten mantener"),_c('br'),_vm._v("\n                       la estructura actual de la empresa,"),_c('br'),_vm._v("\n                        aportando valor al compartir nuestra"),_c('br'),_vm._v("\n                         experiencia y brindando beneficios;"),_c('br'),_vm._v("\n                          respetando en todos los aspectos la Ley"),_c('br'),_vm._v("\n                           Federal del Trabajo, la Ley del Seguro Social"),_c('br'),_vm._v("\n                            y la Ley del Impuesto Sobre la Renta, optimizando"),_c('br'),_vm._v("\n                             el cumplimiento de sus obligaciones fiscales y"),_c('br'),_vm._v("\n                              laborales; Manteniendo las garantías laborales;"),_c('br'),_vm._v("\n                               Simplificando procesos administrativos; Ahorrando"),_c('br'),_vm._v("\n                                tiempos y recursos; Y contando además con asesoría laboral.\n\n              ")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/grupo.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"purple","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Administración correcta de personal.")]),_vm._v(" "),_c('li',[_vm._v("Asesoría para el cumplimiento de obligaciones patronales y fiscales.")]),_vm._v(" "),_c('li',[_vm._v("Cálculo y preparación de Nóminas.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_vm._v("\n                      En los tiempos actuales la empresas  necesitan disponer de "),_c('b',{staticStyle:{"color":"purple"}},[_vm._v("expertos técnicos en Administración laboral")]),_vm._v(", qué, además de confeccionar las nóminas tengan una visión global de las relaciones laborales, siendo que en la mayoría de las pequeñas y medianas empresas, la persona encargada de las nóminas (por falta de tiempo, de formación o de especialización), no consigue dominar todos los aspectos necesarios. En muchos casos esta situación se traduce en sanciones y/o demandas.\n\n                  ")])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/outsourcing_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rh_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_426efa30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rh_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rh_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_426efa30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rh_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0px 0px 0px"}},[_c('section',[_c('v-parallax',{staticClass:"height: 700px",attrs:{"dark":"","src":"../static/img/icons/recursos-humanos_portada.jpg"}},[_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticClass:"font-weight-thin"},[_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"70px","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                        Recursos Humanos\n                    ")])],1)])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","height":"300px","width":"300px","src":"../static/img/icons/recursos humanos.png"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"pt-3 subheading text-xs-center black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Obtener, mantener y desarrollar el capital"),_c('br'),_vm._v(" humano \n                  que cumpla de manera eficiente con los Valores"),_c('br'),_vm._v(" y \n                  Objetivos de la Organización por medio de una"),_c('br'),_vm._v(" \n                  planeación estratégica del área de capital humano,"),_c('br'),_vm._v(" \n                  Formación y Atracción de Talento, Desarrollo"),_c('br'),_vm._v("\n                  Organizacional, Cultura y Comunicación de las"),_c('br'),_vm._v("\n                  Organizaciones."),_c('br')])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-avatar',{attrs:{"size":"250px","aspect-ratio":"1","contain":"","pl-5":"","ml-5":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/rh.jpg","alt":""}})],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3",attrs:{"inset":"","vertical":""}}),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('v-layout',{attrs:{"column":"","pl-5":"","ml-5":""}},[_c('div',{staticClass:"pt-3 text-xs-center subheading black--text",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticStyle:{"font-family":"'Maven Pro', sans-serif"},attrs:{"light":"true","round":"","input-value":"off","depressed":"true","color":"primary","dark":""}},[_c('b',[_vm._v("Alcances")])])],1),_vm._v(" "),_c('h4',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}}),_c('br'),_vm._v(" "),_c('div',[_c('ul',{staticClass:"subhebody-2 text-xs-left",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_c('li',[_vm._v("Políticas y Procedimientos de Capital Humano.")]),_vm._v(" "),_c('li',[_vm._v("Manual de Capacitación y Reglamento Interno de Trabajo.")]),_vm._v(" "),_c('li',[_vm._v("Métodos de Evaluación y Diagnóstico del Desempeño.")]),_vm._v(" "),_c('li',[_vm._v("Identidad Corporativa y Gestión de Talentos.")])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-left"},[_vm._v("\n                      El impacto de los cambios y la modernidad se percibe esencialmente \n                      en la cultura de las organizaciones, en esa “manera de hacer las cosas”.\n                       Esto implica modificaciones en el papel de los equipos de gerentes, en \n                       los estilos de liderazgos y en las relaciones entre departamentos y áreas,\n                        entre gerentes y colaboradores, es decir, en los Recursos Humanos. \n                        La apertura al cambio y la flexibilidad de quienes dirigen las empresas \n                        es un factor vital para que los procesos de transformación se consoliden \n                        adecuadamente. "),_c('br'),_vm._v("\n\n                      El gerente moderno, tanto en Recursos Humanos como en otras áreas, \n                      debe convertirse en agente de cambio para manejar estos procesos, \n                      generar compromiso con ellos y garantizar que se produzca el cambio \n                      deseado. La improvisación no es válida, por lo que nuestro programa \n                      de asesoría en Recursos Humanos "),_c('b',{staticStyle:{"color":"#880E4F"}},[_vm._v("debe garantizar por un lado una correcta \n                      organización del talento y por el otro, un buen clima laboral.")])])])])],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-card',{staticStyle:{"background-color":"#CD2800"}},[_c('br'),_c('br'),_vm._v(" "),_c('v-img',{staticStyle:{"max-width":"100px","max-height":"100px","display":"block","margin-left":"auto","margin-right":"auto"},attrs:{"src":"../static/img/icons/sello-portada.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('span',{staticStyle:{"font-size":"60px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Acércate a los expertos\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"40px","color":"white","font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n              Llena el siguiente formulario y nosotros te contactamos\n          ")]),_vm._v(" "),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md7":""}},[_c('div',{staticStyle:{"max-width":"500px","margin":"auto","padding-top":"50px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"725","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-img',{attrs:{"aspect-ratio":"2.5","contain":"","src":"../static/img/icons/GenialHUB_logo2.png"}}),_vm._v(" "),_c('div',{staticClass:"display-1 py-5 text-md-center"},[_c('h4',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("\n                  Todo lo que "),_c('br'),_vm._v(" necesita un corporativo "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold",staticStyle:{"color":"#CD2800"}},[_vm._v("en un solo lugar")])])]),_vm._v(" "),_c('v-img',{attrs:{"aspect-ratio":"3","contain":"","src":"../static/img/icons/MX-naranja.png"}}),_vm._v(" "),_c('div',{staticClass:"headline py-5 text-md-center"},[_c('h5',{staticClass:"font-weight-thin",staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("Con servicio en todo México")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contacto"}},[_c('v-card',{attrs:{"xs5":"","hidden-md-and-down":""}},[_c('v-img',{attrs:{"src":"../static/img/icons/recursos-humanos_pie.jpg","height":"260"}},[_c('br'),_vm._v(" "),_c('v-card-text',{staticClass:"pt-5 pr-5 mr-5 display-1 text-xs-center font-weight-light white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("¡ Gracias por tu visita !")])]),_vm._v(" "),_c('v-card-text',{staticClass:"title text-xs-center font-weight-thin white--text"},[_c('p',{staticStyle:{"font-family":"'Maven Pro', sans-serif"}},[_vm._v("contacto@genialhub.com | +52 (999) 518 0708")])])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n              Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n              Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n              Usar los contenidos de forma diligente, correcta y lícita.\n              No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n              GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n              El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n              El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n              Información y sitios Web de terceros\n              La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n              El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n              GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n              Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n              GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n              Responsabilidad por la información contenida\n              Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n              GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n              Ley aplicable y jurisdicción\n              El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n              Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n              Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n              Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                DATOS PERSONALES QUE RECABAMOS\n                GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                USO DE SUS DATOS PERSONALES\n                Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                TRANSMISIÓN DE DATOS\n                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                      * Número telefónico: 99 94 90 15 44\n                                      * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                      * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                REVOCACIÓN DE CONSENTIMIENTO\n                En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                MODIFICACIONES AL AVISO DE PRIVACIDAD\n                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                Fecha de última actualización: Diciembre 04 de 2018\n              ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbc7841_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formulario_vue__ = __webpack_require__(60);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cbc7841_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formulario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',[_c('v-footer',{attrs:{"height":"auto","color":"#CD2800"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('V-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog9),callback:function ($$v) {_vm.dialog9=$$v},expression:"dialog9"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Esta página de Internet y su contenido, incluyendo los textos, gráficos, logos e imágenes, son propiedad de GENIAL HUB, S DE RL DE CV. Está prohibida su reproducción total o parcial, su traducción, inclusión, transmisión, almacenamiento o acceso a través de medios analógicos, digitales o de cualquier otro sistema o tecnología creada, sin autorización previa y escrita de GENIAL HUB, S DE RL DE CV.\n                        Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier material de este sitio exclusivamente para uso personal y no comercial, siempre y cuando se haga expresa mención de la propiedad en cabeza de GENIAL HUB, S DE RL DE CV.\n                        Con respecto a los contenidos que aparecen en la página Web de GENIAL HUB, S DE RL DE CV, el usuario se obliga a:\n                        Usar los contenidos de forma diligente, correcta y lícita.\n                        No suprimir, eludir, o manipular el copryght (derecho de autor) y demás datos que identifican los derechos de la empresa GENIAL HUB, S DE RL DE CV S. A. de C.V.\n                        GENIAL HUB, S DE RL DE CV no será responsable del uso indebido que hagan los usuarios de su página Web.\n                        El visitante o usuario de la página Web de GENIAL HUB, S DE RL DE CV no enviará o transmitirá en este sitio Web o hacía el mismo, a otros usuarios o a cualquier persona, cualquier información de alcance obsceno, difamatorio, injuriante, calumniante contra GENIAL HUB, S DE RL DE CV o contra los responsables de la administración de la página Web.\n                        El visitante o usuario de este sitio Web, no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques informáticos, interceptación de comunicaciones, infracciones al derecho de autor, uso no autorizado de terminales, usurpación de identidad, revelación de secretos o falsedad en los documentos.\n                        Información y sitios Web de terceros\n                        La página Web puede ofrecer hipervínculos o accesos a páginas Web y contenidos de otras personas, con el propósito de informar al Usuario sobre la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta ofrece, o que guardan relación con aquéllos. GENIAL HUB, S DE RL DE CV no controla, refrenda ni garantiza el contenido incluido en dichos sitios, tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas Web vinculadas, ni sugiere, invita o recomienda la visita a las mismas, por lo que tampoco será responsable del resultado obtenido.\n                        El usuario acepta que la empresa no es responsable de ningún contenido, enlace asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo, el Usuario acepta que GENIAL HUB, S DE RL DE CV no será responsable de ninguna perdida o daño de cualquier tipo que se derive del uso que se realice de los contenidos de un tercero.\n                        GENIAL HUB, S DE RL DE CV S.A. de C.V. no se responsabiliza por cualquier consecuencia derivada del ingreso indebido de terceros a la base de datos y/o por alguna falla técnica en el funcionamiento y/o conservación de datos en el sistema en cualquiera de los menús de su página Web.\n                        Igualmente, GENIAL HUB, S DE RL DE CV no podrá garantizar la disponibilidad de los servicios en línea y de la información que los usuarios requieran en determinado momento. Tampoco incurrirá en responsabilidad con el usuario o terceros, cuando su página Web no se encuentre disponible.\n                        GENIAL HUB, S DE RL DE CV no responderá en ningún caso y bajo ninguna circunstancia, por los ataques o incidentes contra la seguridad de su página Web o contra sus sistemas de información; o por cualquier exposición o exceso no autorizado, fraudulenta o ilícito a su página Web y que puedan afectar las confidencialidad, integridad o autenticidad de la información publicada o asociada con los contenidos y servicios que se ofrecen en ella.\n                        Responsabilidad por la información contenida\n                        Debido a que en la actualidad los medios técnicos no permiten garantizar la absoluta falta de injerencia de la acción de tercera personas en las páginas Web, GENIAL HUB, S DE RL DE CV de ninguna manera asegura la exactitud y/o veracidad de todo o parte de la información contenida en su página, ni de su actualización, ni que dicha información haya sido alterada o modificada en todo o en parte, luego de haber sido publicada en la página, ni cualquier otro aspecto o característica de lo publicado en el sitio o en los enlaces, respectivamente.\n                        GENIAL HUB, S DE RL DE CV no controla ni garantiza la ausencia de virus ni de otros elementos en los contenidos que puedan producir alteraciones en su sistema informático (software y hardware) o en los documentos electrónicos y ficheros almacenados en su sistema informático.\n                        Ley aplicable y jurisdicción\n                        El usuario no podrá manifestar ante GENIAL HUB, S DE RL DE CV o ante a una autoridad judicial o administrativa, la aplicación de condición, norma o convenio que no esté expresamente incorporado en las presentes condiciones de uso.\n                        Estas condiciones serán gobernadas por la leyes de la República Mexicana, en los aspectos que no estén expresamente regulados en ellas.\n                        Si cualquier disposición de estas condiciones pierde validez o fuerza obligatoria. por cualquier razón, todas las demás disposiciones, conservan su fuerza obligatoria, carácter vinculante y generarán todos sus efectos.\n                        Para cualquier efecto legal o judicial, el lugar de las presentes condiciones es la ciudad de Cancún, y cualquier controversia que surja de su interpretación o aplicación se someterá  los jueces de la República Mexicana.\n                        ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog9 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600px"},model:{value:(_vm.dialog10),callback:function ($$v) {_vm.dialog10=$$v},expression:"dialog10"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Política de Privacidad")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("GENIAL HUB, S DE RL De C.V. (en adelante GENIAL HUB), con domicilio en Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México, con el RFC: GHC-181003-P80 es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.\n                        DATOS PERSONALES QUE RECABAMOS\n                        GENIAL HUB podrá recabar de usted los siguientes datos personales: nombre completo, domicilio, RFC, teléfono, correo electrónico, datos bancarios, referencias personales. Asimismo, podremos solicitar de Usted copia de identificación oficial, comprobante de domicilio, contrato de arrendamiento de inmueble o comprobantes de pago de predial, en su caso.\n                        USO DE SUS DATOS PERSONALES\n                        Sus datos personales serán utilizados para las siguientes finalidades: (i) proveer los servicios y productos requeridos por Usted; (ii) informar sobre cambios o nuevos productos que estén adquiridos por el cliente; (iii) dar cumplimiento a obligaciones contraídas con Usted; (d) evaluar la calidad del servicio; (iv) enviarle ofertas, promociones o publicidad relacionadas con nuestros productos y servicios.\n                        TRANSMISIÓN DE DATOS\n                        Nos comprometemos a no transferir su información personal a terceros sin su consentimiento. salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.\n                        ACCESSO, RETIFICACIÓN, CANCELACIÓN Y OPOSICIÓN DE DATOS PERSONALES\n                        Usted tiene derecho a acceder a sus datos personales que poseemos y a los detalles del tratamiento de los mismos, así como a rectificarlos en caso de ser inexactos o incompletos; cancelarlos cuando considere que no se requieren para alguna de las finalidades señalados en el presente aviso de privacidad, estén siendo utilizados para finalidades no consentidas o haya finalizado la relación de servicio, o bien, oponerse al tratamiento de los mismos para fines específicos.\n                        Los mecanismos que se han implementado para el ejercicio de dichos derechos son a través de la presentación de la solicitud respectiva ante nuestra área de servicio al cliente:\n                                                * Número telefónico: 99 94 90 15 44\n                                                * Correo electrónico: servicioalcliente@genialhub.com.mx\n                                                * Domicilio:   Calle 31-B No. 145 x 14 y 16 CP. 97146 de la ciudad de Mérida, Yucatán, México\n                        Podrá presentar su solicitud en cualquiera de los medios de comunicación mencionados anteriormente.\n                        Su solicitud deberá contener la siguiente información: (i) nombre completo, (ii) derecho que desee ejercer, (iii) datos que requiera acceder, ratificar, cancelar u oponerse a su tratamiento, (iv) en caso que se solicite la rectificación o actualización de sus datos, deberá proporcionar el dato que sustituirá el anterior, (v) en caso de oposición al trato de sus datos, deberá indicar el dato personal y el uso al cual se opone, (vi) en caso de cancelación o acceso, deberá indicar el dato a cancelar o acceder, según sea el caso.\n                        Para mayor información, favor de comunicarse al área de servicio al cliente mencionada anteriormente.\n                        REVOCACIÓN DE CONSENTIMIENTO\n                        En todo momento, Usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de su datos personales, a fin de que dejemos de hacer uso de los mismos. Para ello, es necesario que presente su petición en el área de servicio al cliente, de conformidad con el procedimiento establecido en el punto anterior.\n                        Si como consecuencia de la revocación de su consentimiento no es posible brindar el servicio o producto contratado por Usted, se entenderá que el mismo se ha dado por terminado por parte suya, sin ninguna responsabilidad para GENIAL HUB.\n                        MODIFICACIONES AL AVISO DE PRIVACIDAD\n                        Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a las presentes políticas de privacidad. Estas modificaciones estarán disponibles al público a través de los siguientes medios: (i) anuncios visibles en nuestros establecimientos o centros de atención a clientes, (ii) trípticos o folletos disponibles en nuestro establecimientos o centros de atención a clientes, (iii) en nuestra página de Internet http://wwww.GENIALHUB.COM, sección de políticas de privacidad, (iv) o se la haremos llegar al último correo electrónico que nos haya proporcionado.\n                        Fecha de última actualización: Diciembre 04 de 2018\n                        ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog10 = false}}},[_vm._v("Lo he leído")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"black":"","py-3":"","text-xs-right":"","white--text":"","xs12":"","row":""}},[_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"unhover":""}},[_c('h4',[_c('strong',[_vm._v("GenialHub")]),_vm._v(" ©2018")])]),_vm._v(" "),_c('v-btn',{staticClass:"black white--text mr-5 pr-5",attrs:{"disabled":""}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-5 font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog9 = true}},slot:"activator"},[_c('h4',[_vm._v("Términos y condiciones")])]),_vm._v(" "),_c('v-btn',{staticClass:"font-weight-thin caption",attrs:{"slot":"activator","color":"white","flat":""},on:{"click":function($event){_vm.dialog10 = true}},slot:"activator"},[_c('h4',[_vm._v("Política de Privacidad")])])],1)],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"700px","margin":"auto","padding-top":"100px"},attrs:{"id":"e3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScfBlZOtcg_BMq3jJjbfMDHSM32FGeUETOoM0XFcwN_bxkhng/viewform?embedded=true","width":"640","height":"625","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.6d8235e0482813a9bd58.js